'use client';

import BenefitIcon from '@/fo/icons/base/doctor/benefit.svg';

import { DoctorFeature } from '../../types';

import { styles } from './ClinicsList.styles';

export interface ClinicsListProps {
  clinics: DoctorFeature[];
  selectedClinic?: DoctorFeature | null;
  onClinicClick: (clinic: DoctorFeature) => void;
  className?: string;
}

export function ClinicsList({
  clinics,
  selectedClinic,
  onClinicClick,
  className
}: ClinicsListProps) {
  const slots = styles();

  const renderClinic = (clinic: DoctorFeature, index: number) => {
    const isSelected = selectedClinic?.id === clinic.id;
    const { clinics: clinicsList } = clinic.properties;
    const currentClinic = clinicsList?.[index] || null;

    if (!currentClinic) return null;

    return (
      <div
        key={clinic.id}
        onClick={() => onClinicClick(clinic)}
        className={slots.address({ selected: isSelected })}
      >
        <BenefitIcon className={slots.icon()} />
        <div className={slots.content()}>
          <p className={slots.title()}>{currentClinic.name}</p>
          <p className={slots.street()}>{currentClinic.address}</p>
          <a
            href={`tel:${currentClinic.telephone}`}
            className={slots.phone()}
          >
            {currentClinic.telephone}
          </a>
        </div>
      </div>
    );
  };

  return (
    <div className={slots.base({ className })}>
      {clinics.length > 0 && (
        <div className={slots.addresses()}>{clinics.map(renderClinic)}</div>
      )}
    </div>
  );
}
